import { authActions } from "../redux/actions";
import MetaMaskOnboarding from "@metamask/onboarding";
import Web3 from "web3";
import { toBuffer } from 'ethereumjs-util'
import {walletActions} from "../redux/actions/walletActions";
import {poolActions} from "../redux/actions/poolActions";
import {swapActions} from "../redux/actions/swapActions";
import {stakePoolActions} from "../redux/actions/stakePoolActions";
import {earnActions} from "../redux/actions/earnActions";
import {voteActions} from "../redux/actions/voteActions";
import {formDateString, formatChainIdNumber, isValidBtcAddress, isValidDogeAddress} from "./Common";
import { roundingDown } from './RoundingDown'
import { isChrome, isIOS, isAndroid, isWindows, isMacOs } from 'react-device-detect'
import { verifyMessage } from "@unisat/wallet-utils";
import bitcore from "bitcore-lib";
import { wallet } from "../redux/reducers/wallet";
import { auth } from "../redux/reducers/auth";
import Unknown from '../images/unknown.png'
import { toast } from 'sonner';
import i18n from '../i18n';

const currentUrl = new URL(window.location.href)
const forwarderOrigin = currentUrl.hostname === 'localhost'
    ? 'http://localhost:9010'
    : undefined

export const onBoard = new MetaMaskOnboarding({ forwarderOrigin })

export const unlock = async (address, chainId, network, code, Web3, registered, dispatch, setOpenSliderModal, setSignUpPayload) => {
    try {
        let msg = 'Access SonicEx wallet.\n' +
            '\n' +
            'Only sign this message for a trusted client!'
        dispatch(authActions.authSigning())
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        // const _msg = Web3.utils.soliditySha3(msg);
        const sign = await window.ethereum.request({
            method: 'personal_sign',
            params: [readable, from],
        })
        let payload = {
            referralCode: code,
            personalSign: {
                data: buffer,
                sig: sign,
                pubKeyAddress: address,
                chainId: Web3.utils.hexToNumber(chainId),
                networkId: Number(network)
            }
        }

        if (registered !== undefined) {
            if (registered) {
                dispatch(authActions.logIn(payload.personalSign))
            } else {
                setOpenSliderModal(true)
                setSignUpPayload(payload)
            }
        } else {
            console.log('not found!')
        }

    } catch (err) {
        console.error('sign error: ', err)
        dispatch(authActions.logOut())
    }
}

export const withdraw = async (address, chainId, network, Web3, registered, dispatch, walletSigning, setTime, handleOpenNote, coin, chain, withdrawAmount, withdrawTo, token) => {
    let msg = 'Withdrawing from SonicEx wallet\n\n' +
        `Amount: ${withdrawAmount} ${coin}\n` +
        `To: ${withdrawTo}\n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(walletActions.walletSigning())
        if (!walletSigning) {
            setTime(formDateString(new Date().getTime()))
            handleOpenNote()

            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                personalSign: {
                    data: buffer,
                    sig: sign,
                    pubKeyAddress: address,
                    chainId: Web3.utils.hexToNumber(chainId),
                    networkId: Number(network),
                },
                currency: coin,
                chain: chain,
                amount: withdrawAmount,
                address: withdrawTo,
                token: token
            }
            dispatch(walletActions.withdraw(payload))
        }

    } catch (err) {
        console.error('withdraw request cancelled: ', err)
        dispatch(walletActions.walletSigningCancelled())
    }
}


export const transfer = async (address, chainId, network, Web3, registered, dispatch, walletSigning, setTime, handleOpenNote, coin, amount, receiverUserId, sendByAddress, token) => {
    let msg = 'Transfer from SonicEx wallet\n\n' +
        `Amount: ${amount} ${coin}\n` +
        `To: ${receiverUserId}\n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(walletActions.walletSigning())
        if (!walletSigning) {
            setTime(formDateString(new Date().getTime()))
            handleOpenNote()

            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {

                body: {
                    token: coin,
                    amount: amount,
                    receiverUserId: receiverUserId,
                    sendByAddress: sendByAddress,
                    personalSign: {
                        data: buffer,
                        sig: sign,
                        pubKeyAddress: address,
                        chainId: Web3.utils.hexToNumber(chainId),
                        networkId: Number(network),
                    },
                },

                token: token

            }
            dispatch(walletActions.transfer(payload))
        }

    } catch (err) {
        console.error('transfer request cancelled: ', err)
        dispatch(walletActions.walletSigningCancelled())
    }
}

export const stake = async (address, chainId, network, Web3, dispatch, stakePoolSigning,pid,coin, amount1,setAmount1, token, handleClose,setSnackBarVisible,isLpLocked) => {
    let msg = 'Staking from SonicEx wallet\n\n' +
        `Stake: ${roundingDown(amount1, 8)} ${coin} \n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(stakePoolActions.stakePoolSigning())

        if (!stakePoolSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                personalSign: {
                    data: buffer,
                    sig: sign,
                    pubKeyAddress: address,
                    chainId: Web3.utils.hexToNumber(chainId),
                    networkId: Number(network),
                },
                pid: pid,
                coin: coin,
                amount: amount1,
                isLock:isLpLocked
            }
            dispatch(stakePoolActions.stake(payload, token))
            setAmount1("")
            handleClose()
        }
    } catch (err) {
        console.error('stake request cancelled: ', err)
        setSnackBarVisible(true)
        dispatch(stakePoolActions.stakePoolSigningCancelled())
    }
}

export const unStake = async (address, chainId, network, Web3, dispatch, stakePoolSigning,pid,coin, amount1,setAmount1, token, handleClose,setSnackBarVisible) => {
    let msg = 'UnStaking from SonicEx wallet\n\n' +
        `UnStake: ${roundingDown(amount1, 8)} ${coin} \n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(stakePoolActions.stakePoolSigning())

        if (!stakePoolSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                personalSign: {
                    data: buffer,
                    sig: sign,
                    pubKeyAddress: address,
                    chainId: Web3.utils.hexToNumber(chainId),
                    networkId: Number(network),
                },
                pid: pid,
                coin: coin,
                amount: amount1,
            }
            dispatch(stakePoolActions.unStake(payload, token))
            setAmount1("")
            handleClose()
        }
    } catch (err) {
        console.error('unStake request cancelled: ', err)
        setSnackBarVisible(true)
        dispatch(stakePoolActions.stakePoolSigningCancelled())
    }
}

export const earnStake = async (address, chainId, network, Web3, dispatch, earnPoolSigning,pid,coin, amount1,setAmount1, token, handleClose,setSnackBarVisible) => {
    let msg = 'Staking Earn from SonicEx wallet\n\n' +
        `Stake: ${roundingDown(amount1, 8)} ${coin} \n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(earnActions.earnPoolSigning())

        if (!earnPoolSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                personalSign: {
                    data: buffer,
                    sig: sign,
                    pubKeyAddress: address,
                    chainId: Web3.utils.hexToNumber(chainId),
                    networkId: Number(network),
                },
                pid: pid,
                amount: amount1,
            }
            dispatch(earnActions.earnStake(payload, token))
            dispatch(earnActions.clearEarnRateQuote())
            setAmount1("")
            handleClose()
        }
    } catch (err) {
        console.error('stake earn request cancelled: ', err)
        setSnackBarVisible(true)
        dispatch(earnActions.earnPoolSigningCancelled())
    }
}

export const earnUnStake = async (address, chainId, network, Web3, dispatch, earnPoolSigning,pid,coin, amount1,setAmount1, token, handleClose,setSnackBarVisible) => {
    let msg = 'UnStaking Earn from SonicEx wallet\n\n' +
        `UnStake: ${roundingDown(amount1, 8)} ${coin} \n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(earnActions.earnPoolSigning())

        if (!earnPoolSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                personalSign: {
                    data: buffer,
                    sig: sign,
                    pubKeyAddress: address,
                    chainId: Web3.utils.hexToNumber(chainId),
                    networkId: Number(network),
                },
                pid: pid,
                amount: amount1,
            }
            dispatch(earnActions.earnUnStake(payload, token))
            setAmount1("")
            handleClose()
        }
    } catch (err) {
        console.error('unStake earn request cancelled: ', err)
        setSnackBarVisible(true)
        dispatch(earnActions.earnPoolSigningCancelled())
    }
}

export const lockLp = async (address, chainId, network, Web3, dispatch, poolSigning,pid, amount, setAmount1,token1,token2, token, handleClose, setSnackBarVisible) => {
    let msg = 'Lock from SonicEx wallet\n\n' +
        `Lock: ${roundingDown(amount, 8)} ${token1+'-'+token2+'-LP'} \n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(poolActions.poolSigning())

        if (!poolSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                personalSign: {
                    data: buffer,
                    sig: sign,
                    pubKeyAddress: address,
                    chainId: Web3.utils.hexToNumber(chainId),
                    networkId: Number(network),
                },
                amount,
                pid,
                token,
            }
            dispatch(poolActions.lockLp(payload))
            setAmount1("")
            handleClose()
        }
    } catch (err) {
        console.error('lock LP request cancelled: ', err)
        setSnackBarVisible(true)
        dispatch(poolActions.poolSigningCancelled())
    }
}

export const unlockLp = async (address, chainId, network, Web3, dispatch, poolSigning,lockerId, amount, setAmount1,token1,token2, token, handleClose, setSnackBarVisible) => {
    let msg = 'Unlock from SonicEx wallet\n\n' +
        `Unlock: ${roundingDown(amount, 8)} ${token1+'-'+token2+'-LP'} \n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(poolActions.poolSigning())

        if (!poolSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                personalSign: {
                    data: buffer,
                    sig: sign,
                    pubKeyAddress: address,
                    chainId: Web3.utils.hexToNumber(chainId),
                    networkId: Number(network),
                },
                amount,
                lockerId,
                token,
            }
            dispatch(poolActions.unlockLp(payload))
            setAmount1("")
            handleClose()
        }
    } catch (err) {
        console.error('unlock LP request cancelled: ', err)
        setSnackBarVisible(true)
        dispatch(poolActions.poolSigningCancelled())
    }
}

export const unlockAllLp = async (address, chainId, network, Web3, dispatch, poolSigning, token,setSnackBarVisible, snackBarMessage,t) => {
    let msg = 'Unlock all liquidity from SonicEx wallet\n\n' +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(poolActions.poolSigning())

        if (!poolSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                data: buffer,
                sig: sign,
                pubKeyAddress: address,
                chainId: Web3.utils.hexToNumber(chainId),
                networkId: Number(network),
                token
            }
            dispatch(poolActions.unlockAllLp(payload))
        }
    } catch (err) {
        console.error('unlock all LP request cancelled: ', err)
        snackBarMessage(t('actionCancelled'))
        setSnackBarVisible(true)
        dispatch(poolActions.poolSigningCancelled())
    }
}

export const stakeLock = async (address, chainId, network, Web3, dispatch, stakePoolSigning,pid, amount, setAmount1,token1, token, handleClose, setSnackBarVisible) => {
    let msg = 'Lock from SonicEx wallet\n\n' +
        `Lock: ${roundingDown(amount, 8)} ${token1} \n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(stakePoolActions.stakePoolSigning())

        if (!stakePoolSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                personalSign: {
                    data: buffer,
                    sig: sign,
                    pubKeyAddress: address,
                    chainId: Web3.utils.hexToNumber(chainId),
                    networkId: Number(network),
                },
                amount,
                pid,
                token,
            }
            dispatch(stakePoolActions.stakeLock(payload))
            setAmount1("")
            handleClose()
        }
    } catch (err) {
        console.error('stake lock request cancelled: ', err)
        setSnackBarVisible(true)
        dispatch(stakePoolActions.stakePoolSigningCancelled())
    }
}

export const stakeUnlock = async (address, chainId, network, Web3, dispatch, stakePoolSigning,lockerId, amount, setAmount1,token1, token, handleClose, setSnackBarVisible) => {
    let msg = 'Unlock from SonicEx wallet\n\n' +
        `Unlock: ${roundingDown(amount, 8)} ${token1} \n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(stakePoolActions.stakePoolSigning())

        if (!stakePoolSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                personalSign: {
                    data: buffer,
                    sig: sign,
                    pubKeyAddress: address,
                    chainId: Web3.utils.hexToNumber(chainId),
                    networkId: Number(network),
                },
                amount,
                lockerId,
                token,
            }
            dispatch(stakePoolActions.stakeUnlock(payload))
            setAmount1("")
            handleClose()
        }
    } catch (err) {
        console.error('stake unlock request cancelled: ', err)
        setSnackBarVisible(true)
        dispatch(stakePoolActions.stakePoolSigningCancelled())
    }
}

export const unlockAllStake = async (address, chainId, network, Web3, dispatch, poolSigning, token,setSnackBarVisible, snackBarMessage,t) => {
    let msg = 'Unlock all Stake from SonicEx wallet\n\n' +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(stakePoolActions.stakePoolSigning())

        if (!poolSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                data: buffer,
                sig: sign,
                pubKeyAddress: address,
                chainId: Web3.utils.hexToNumber(chainId),
                networkId: Number(network),
                token
            }
            dispatch(stakePoolActions.unlockAllStake(payload))
        }
    } catch (err) {
        console.error('unlock all stake request cancelled: ', err)
        snackBarMessage(t('actionCancelled'))
        setSnackBarVisible(true)
        dispatch(stakePoolActions.stakePoolSigningCancelled())
    }
}

export const vote = async (address, chainId, network, Web3, dispatch, voteSigning,pid, amount1,setAmount1, token, handleClose,setSnackBarVisible,option) => {
    let msg = 'Voting from SonicEx wallet\n\n' +
        `Vote: ${roundingDown(amount1, 8)} \n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(voteActions.voteSigning())

        if (!voteSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                personalSign: {
                    data: buffer,
                    sig: sign,
                    pubKeyAddress: address,
                    chainId: Web3.utils.hexToNumber(chainId),
                    networkId: Number(network),
                },
                pid: pid,
                amount: amount1,
                option:option
            }
            dispatch(voteActions.vote(payload, token))
            setAmount1("")
            handleClose()
        }
    } catch (err) {
        console.error('vote request cancelled: ', err)
        setSnackBarVisible(true)
        dispatch(voteActions.voteSigningCancelled())
    }
}

export const buyIDO = async (address, chainId, network, Web3, dispatch, walletSigning, buyAmount, idoStartTime, token, handleCloseBuyModal, setBuyAmount, setSnackBarVisible, setSnackMsg, t) => {
    let msg = 'Purchasing IDO from SonicEx wallet\n\n' +
        `IdoAmount: ${buyAmount} USDT \n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(walletActions.walletSigning())

        if (!walletSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                personalSign: {
                    data: buffer,
                    sig: sign,
                    pubKeyAddress: address,
                    chainId: Web3.utils.hexToNumber(chainId),
                    networkId: Number(network),
                },
                usdtAmount: buyAmount,
                isPreIdo:new Date(idoStartTime).getTime() > new Date().getTime(),
            }
            dispatch(walletActions.buyIDO(payload, token))
            setBuyAmount("")
            handleCloseBuyModal()
        }
    } catch (err) {
        console.error('buy ido request cancelled: ', err)
        setSnackMsg(t('actionCancelled'))
        setSnackBarVisible(true)
        dispatch(walletActions.walletSigningCancelled(err))
    }
}

export const migrateIDO = async (address, chainId, network, Web3, dispatch, walletSigning, migrateAmount, token, handleCloseMigrateModal, setMigrateAmount, t) => {
    let msg = 'IDO Migrate from SonicEx wallet\n\n' +
        `migrateAmount: ${migrateAmount} SAP \n` +
        `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    try {
        const from = address
        const readable = `0x${Buffer.from(msg, 'utf8').toString('hex')}`
        const buffer = [...toBuffer(readable)]
        dispatch(walletActions.walletSigning())

        if (!walletSigning) {
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [readable, from],
            })
            let payload = {
                personalSign: {
                    data: buffer,
                    sig: sign,
                    pubKeyAddress: address,
                    chainId: Web3.utils.hexToNumber(chainId),
                    networkId: Number(network),
                },
                sapAmount: migrateAmount
            }
            dispatch(walletActions.migrateIDO(payload, token))
            setMigrateAmount("")
            handleCloseMigrateModal()
        }
    } catch (err) {
        console.error('Ido migrate request cancelled: ', err)
        dispatch(walletActions.migrateSigningCancelled(err))
    }
}

export const isMetaMaskConnected = (address) => {
    return address !== ''
}

export const onClickInstall = (setButton1, setButton1Disabled) => {
    onBoard.startOnboarding()
    setButton1('Onboarding in progress')
    setButton1Disabled(true)
}

export const onClickConnect = async (network, chainId, addr, dispatch, handleOpen, registered, loggedIn, loading) => {
    let _chainId
    let _network
    try {
        if (chainId === 0) {
            _chainId = await window.ethereum.request({
                method: 'eth_chainId',
            })

            _network = await window.ethereum.request({
                method: 'net_version',
            })
        }
        await window.ethereum.request({
            method: 'eth_requestAccounts',
        })
        if (!!window.imToken) {
            if (registered !== undefined && loggedIn !== undefined && loading !== undefined) {
                if (chainId === 0) {
                    unlock(addr, _chainId, _network, Web3, false, dispatch)
                } else {
                    await unlock(addr, chainId, network, Web3, false, dispatch)
                }
            }
        } else {
            if (handleOpen !== undefined) {
                handleOpen()
            }
        }

    } catch (error) {
        console.error(error)
    }
}

export const onClickUnisatWallet = async () => {
    try {
        let acct = await window.unisat.requestAccounts()
        let network = await window.unisat.getNetwork()
        console.log('get unisat acct res: ', acct, network)
        return {
            success: true,
            addr: acct,
            network: network,
            chainId: '0xc6'
        }

    } catch(err) {
        console.log('get unisat acct failed: ', err)
        return {
            success: false,
            msg: err
        }
    }
}

export const onClickUnielonWallet = async () => {
    try {
        let acct = await window.unielon.requestAccounts()
        let network = await window.unielon.getNetwork()
        console.log('get unielon acct res: ', acct, network)
        return {
            success: true,
            addr: acct,
            network: network,
            chainId: '0x396'
        }

    } catch(err) {
        console.log('get unielon acct failed: ', err)
        return {
            success: false,
            msg: err
        }
    }
}

export const onClickInstallUnisat = () => {
    if (isChrome) {
        window.open('https://chromewebstore.google.com/detail/unisat-wallet/ppbibelpcjmhbdihakflkdcoccbgbkpo', '_blank')
    } 
    
    else {
        let msg = 'chromeOnly'
        if (isIOS) {
            // window.open('https://apps.apple.com/us/app/unisat-inscribe-your-dreams/id6498628503', '_blank')
            msg = 'noMobile'
        } else if (isAndroid) {
            // window.open('https://play.google.com/store/apps/details?id=io.unisat&pli=1', '_blank')
            msg = 'noMobile'
        } 
        toast(
            <div style={{ width: 500 }}>
              <div>{i18n.t(msg, { interpolation: { escaleValue: false } })}</div>
            </div>
          );
    }
}

export const onClickInstallOKX = () => {
    if (isChrome) {
        window.open('https://chromewebstore.google.com/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge?hl=en', '_blank')
    } 
    else {
        let msg = 'chromeOnly'
        if (isIOS) {
            //     window.open('https://apps.apple.com/us/app/okx-buy-bitcoin-btc-crypto/id1327268470', '_blank')
            msg = 'noMobile'
        } else if (isAndroid) {
            //     window.open('https://static.vnugkh.cn/upgradeapp/okx-android.apk', '_blank')
            msg = 'noMobile'
        } 
        toast(
            <div style={{ width: 500 }}>
              <div>{i18n.t(msg, { interpolation: { escaleValue: false } })}</div>
              </div>
          );
        
    }
}

export const UnisatSign = async (msg, dispatch) => {
    try {
        if (typeof window.unisat !== 'undefined') {
        let res = await window.unisat.signMessage(msg);
        return {
            success: true,
            sig: res,
        };
        }
    } catch (e) {
        console.log('unisat sign failed: ', e);
        dispatch(walletActions.setWalletMsg(e.message))
        return {
        success: false,
        error: e,
        };
    }
};
  
export const OkxBtcSign = async (msg, dispatch) => {
    try {
        if (typeof window.okxwallet !== 'undefined') {
        let res = process.env.NEXT_PUBLIC_NETWORK === 'testnet' ?  await window.okxwallet.bitcoinTestnet.signMessage(msg, 'ecdsa') : await window.okxwallet.bitcoin.signMessage(msg, 'ecdsa');
        return {
            success: true,
            sig: res,
        };
        }
    } catch (e) {
        console.log('OKX sign failed: ', e);
        dispatch(walletActions.setWalletMsg(e.message))
        return {
        success: false,
        error: e,
        };
    }
}

export const UnielonSign = async (msg, dispatch) => {
    try {
        if (typeof window.unisat !== 'undefined') {
        let res = await window.unielon.signMessage(msg);
        return {
            success: true,
            sig: res,
        };
        }
    } catch (e) {
        console.log('unielon sign failed: ', e);
        dispatch(walletActions.setWalletMsg(e.message))
        return {
        success: false,
        error: e,
        };
    }
}
  
export const onClickInstallUnielon = () => {
    if (isChrome) {
        window.open('https://chromewebstore.google.com/detail/unielon/inlkhilmjmjomfcpdifpfgllhhlpnbej?hl=en&pli=1', '_blank')
    } 
    else {
        let msg = 'chromeOnly'
        if (isIOS) {
            //     window.open('https://apps.apple.com/us/app/okx-buy-bitcoin-btc-crypto/id1327268470', '_blank')
            msg = 'noMobile'
        } else if (isAndroid) {
            //     window.open('https://static.vnugkh.cn/upgradeapp/okx-android.apk', '_blank')
            msg = 'noMobile'
        } 
        toast(
            <div style={{ width: 500 }}>
              <div>{i18n.t(msg, { interpolation: { escaleValue: false } })}</div>
              </div>
          );
        
    }
}

export const VerifyUnisatSign = () => {
    const pubkey = "02a786c4eee5c1a998e96b22c21a3120049eb83047b05abd101a18a36344feb307";
    const message = "Access SonicEx wallet.\n\nOnly sign this message for a trusted client!";
    const signature = "G43n/OhMXOrMm5FxmowW739phCzwjYUaWUzrwlPA74HXQl7u5LLoSuURbN8Km0i/TZw/+9Cflic5HlzmFadWSLI=";
    const result = verifyMessage(pubkey,message,signature);
}

export const VerifyUnisatSignUsingNewBitcore = async (
    text,
    sig,
    wallet
  ) => {
    let publicKey = '';
    let addr = [];
    // console.log('verifying: ', text, sig, wallet)
    try {
      if (wallet.name === 'Unisat' && typeof window.unisat !== 'undefined') {
        addr = await window.unisat.getAccounts();
        publicKey = await window.unisat.getPublicKey();
      } else if (wallet.name === 'OKX Wallet' && typeof window.okxwallet !== 'undefined') {
        addr = await window.okxwallet.bitcoin.getAccounts();
        publicKey = await window.okxwallet.bitcoin.getPublicKey();
      } else if (wallet.name === 'Unielon Wallet' && typeof window.unielon !== 'undefined') {
        addr = await window.unielon.getAccounts();
        publicKey = await window.unielon.getPublicKey();
      } else {
        console.log(`Invalid wallet type: ${JSON.stringify(wallet)}`)
        return false
      }
    } catch (err) {
      console.log('get public key failed: ', err);
    }
    try {
      let message = new bitcore.Message(text);
  
      let signature = bitcore.crypto.Signature.fromCompact(
        Buffer.from(sig, 'base64')
      );
  
      let hash = message.magicHash();
  
      // recover the public key
      let ecdsa = new bitcore.crypto.ECDSA();
      ecdsa.hashbuf = hash;
      ecdsa.sig = signature;
      let pubkeyInSig = ecdsa.toPublicKey();
      let pubkeyInSigString = new bitcore.PublicKey(
        Object.assign({}, pubkeyInSig.toObject(), {
          compressed: true,
        })
      ).toString();
      if (pubkeyInSigString !== publicKey) {
        return false;
      }
      let res = bitcore.crypto.ECDSA.verify(hash, signature, pubkeyInSig);
      return res;
    } catch (err) {
      console.log('verify failed: ', err);
      return false;
    }
  };

export const unlockNew = async (
    address,
    chainId,
    network,
    registered,
    currentWallet,
    dispatch, 
    setAddress, setChainId, setNetwork, setWallet, setDappConnected, setPublicKey, setStartWatch, setAutoSign, setWalletDisconnected
) => {
    // console.log('unlock btc: ', address, chainId, network, currentWallet, registered)
  
    if (isValidBtcAddress(address) || isValidDogeAddress(address)) {
      if (typeof window.unisat !== 'undefined' || typeof window.unielon !== 'undefined') {
        console.log('signing !: ', currentWallet, registered);
  
        try {
          dispatch(walletActions.setWalletMsg(''))
          let msg = 
            'Access SonicEx wallet.\n' +
            '\n' +
            'Only sign this message for a trusted client!';
          let res
          if (currentWallet.name === 'Unisat') {
            res = await UnisatSign(msg, dispatch);
            
          } else if (currentWallet.name === 'OKX Wallet') {
            res = await OkxBtcSign(msg, dispatch);
          } else if (currentWallet.name === 'Unielon Wallet') {
            res = await UnielonSign(msg, dispatch);
            VerifyUnisatSign()
          } else {
            res = { success:false, message: `Invalid wallet type: ${JSON.stringify(currentWallet)}` }
          }
          
          if (res.success) {
            let verifyFrontend = await VerifyUnisatSignUsingNewBitcore(
              msg,
              res.sig,
              currentWallet
            );
            if (verifyFrontend) {
              let pubKey = currentWallet.name === 'Unisat' ?  await window.unisat.getPublicKey() : currentWallet.name === 'Unielon Wallet' ? await window.unielon.getPublicKey() : await window.okxwallet.bitcoin.getPublicKey()
              let _chainId = formatChainIdNumber(chainId)
              let payload = {
                referralCode: '',
                btcPersonalSign: {
                  address: address,
                  message: msg,
                  signedMessage: res.sig,
                  pubKey: pubKey,
                  network,chainId: _chainId
                },
              };
              if (registered !== undefined) {
                console.log('registered status: ', registered)
                if (registered) {
                    dispatch(authActions.logIn(payload.btcPersonalSign, currentWallet.chain))
                } else {
                    dispatch(authActions.signUp(payload, currentWallet.chain))
                }
              } else {
                console.log('address not found!');
                dispatch(walletActions.setWalletMsg('No BTC connection detected !'))
              }
            } else {
              dispatch(walletActions.setWalletMsg('Invalid signature !'))
            }
          } 
            setAutoSign(false)
            setTimeout(() => {
                dispatch(authActions.authSignFinished());
            }, 1000)
        } catch (err) {
          console.error('unlock BTC address error: ', err);
          dispatch(walletActions.setWalletMsg(err.message))
          dispatch(authActions.authSignFinished());
          setAutoSign(false)
          LogOut(dispatch, address, chainId, network, setAddress, setChainId, setNetwork, setPublicKey, setDappConnected, setWallet, setStartWatch, setWalletDisconnected)
        }
      }
    } 
  };


  export const swap = async (address, chainId, network, Web3, dispatch, swapSigning, pairOne, pairTwo, amount1, amount2, setAmount1, setAmount2, token, setSnackBarMessage, setSnackBarVisible, t, currentWallet) => {
    if (!swapSigning) {
        dispatch(swapActions.swapSigning())
        try {
            dispatch(walletActions.setWalletMsg(''))
            let msg = 'Swapping from SonicEx wallet\n\n' +
            `Swap: ${roundingDown(amount1, 8)} ${pairOne} \n` +
            `For: ${roundingDown(amount2, 8)} ${pairTwo}\n` +
            `ChainId: ${Web3.utils.hexToNumber(chainId)}`
    
            let res
            if (currentWallet.name === 'Unisat') {
              res = await UnisatSign(msg, dispatch);              
            } else if (currentWallet.name === 'OKX Wallet') {
              res = await OkxBtcSign(msg, dispatch);
            } else if (currentWallet.name === 'Unielon Wallet') {
              res = await UnielonSign(msg, dispatch);
            } 
              else {
              res = { success:false, message: `Invalid wallet type: ${JSON.stringify(currentWallet)}` }
            }
    
            if (res.success) {
                let verifyFrontend = await VerifyUnisatSignUsingNewBitcore(
                  msg,
                  res.sig,
                  currentWallet
                );
                
                if (verifyFrontend) {
                    let publicKey = currentWallet.name === 'Unisat' ?  await window.unisat.getPublicKey() : currentWallet.name === 'Unielon Wallet' ? await window.unielon.getPublicKey() : await window.okxwallet.bitcoin.getPublicKey()
                    let payload = {
                        btcPersonalSign: {
                            address: address,
                            message: msg,
                            signedMessage: res.sig,
                            pubKey: publicKey,
                            },
                        from: pairOne,
                        to: pairTwo,
                        fromAmount: amount1,
                        toAmount: amount2
                    }
                    dispatch(swapActions.swap(payload, token))
                    setAmount1("")
                    setAmount2("")
                } else {
                  dispatch(walletActions.setWalletMsg('Invalid signature !'))
                }
            } else {
                setSnackBarMessage(t('actionCancelled'))
                setSnackBarVisible(true)
                dispatch(swapActions.swapSigningCancelled())
            }
        } catch (err) {
            console.error('swap request cancelled: ', err)
            setSnackBarMessage(t('actionCancelled'))
            setSnackBarVisible(true)
            dispatch(swapActions.swapSigningCancelled())
        }
    }
}

export const addLiquidity = async (address, chainId, currentWallet, Web3, dispatch, poolSigning,isLpLocked, token1, token2, amount1, amount2, setAmount1, setAmount2, token, handleClose, setSnackBarVisible) => {
    if (!poolSigning) {
        dispatch(poolActions.poolSigning())
        try {
            dispatch(walletActions.setWalletMsg(''))
            let msg = 'Adding Liquidity from SonicEx wallet\n\n' +
            `Adding: ${roundingDown(amount1, 8)} ${token1} \n` +
            `and: ${roundingDown(amount2, 8)} ${token2}\n` +
            `ChainId: ${Web3.utils.hexToNumber(chainId)}`

            let res
            if (currentWallet.name === 'Unisat') {
                res = await UnisatSign(msg, dispatch);
                
            } else if (currentWallet.name === 'OKX Wallet') {
                res = await OkxBtcSign(msg, dispatch);
            } else if (currentWallet.name === 'Unielon Wallet') {
                res = await UnielonSign(msg, dispatch);
            } else {
                res = { success:false, message: `Invalid wallet type: ${JSON.stringify(currentWallet)}` }
            }

            if (res.success) {
                let verifyFrontend = await VerifyUnisatSignUsingNewBitcore(
                    msg,
                    res.sig,
                    currentWallet
                );
                if (verifyFrontend) {
                    let publicKey = currentWallet.name === 'Unisat' ?  await window.unisat.getPublicKey() : currentWallet.name === 'Unielon Wallet' ? await window.unielon.getPublicKey() : await window.okxwallet.bitcoin.getPublicKey()
                    let payload = {
                        btcPersonalSign: {
                            address: address,
                            message: msg,
                            signedMessage: res.sig,
                            pubKey: publicKey
                        },
                        token1,
                        token2,
                        amount1,
                        amount2,
                        token,
                        isLpLocked
                    }
                    dispatch(poolActions.addLiquidity(payload))
                    setAmount1("")
                    setAmount2("")
                    dispatch(poolActions.clearAddQuote())
                    handleClose()                    
                } else {
                    dispatch(walletActions.setWalletMsg('Invalid signature !'))
                }
            } else {
                setSnackBarVisible(true)    
                dispatch(poolActions.poolSigningCancelled())
                console.log('sign failed: ', res)
            }
            
        } catch (err) {
            console.error('add liquidity request cancelled: ', err)
            setSnackBarVisible(true)
            dispatch(poolActions.poolSigningCancelled())
        }
        
    }
    
}








export const removeLiquidity = async (address, chainId, currentWallet, Web3, dispatch, poolSigning, token1, token2, amount, setAmount1, setAmount2, token, handleClose, setSnackBarVisible) => {
    if (!poolSigning) {
        dispatch(poolActions.poolSigning())
        try {
            dispatch(walletActions.setWalletMsg(''))
            let msg = 'Removing Liquidity from SonicEx wallet\n\n' +
            `Removing: ${roundingDown(amount, 8)} ${token1}-${token2}-LP \n` +
            `ChainId: ${Web3.utils.hexToNumber(chainId)}`
            let res
            if (currentWallet.name === 'Unisat') {
                res = await UnisatSign(msg, dispatch);                
            } else if (currentWallet.name === 'OKX Wallet') {
                res = await OkxBtcSign(msg, dispatch);
            } else if (currentWallet.name === 'Unielon Wallet') {
                res = await UnielonSign(msg, dispatch);
            } else {
                res = { success:false, message: `Invalid wallet type: ${JSON.stringify(currentWallet)}` }
            }

            if (res.success) {
                let verifyFrontend = await VerifyUnisatSignUsingNewBitcore(
                    msg,
                    res.sig,
                    currentWallet
                );
                if (verifyFrontend) {
                    let publicKey = currentWallet.name === 'Unisat' ?  await window.unisat.getPublicKey() : currentWallet.name === 'Unielon Wallet' ? await window.unielon.getPublicKey() : await window.okxwallet.bitcoin.getPublicKey()
                    let payload = {
                        btcPersonalSign: {
                            address: address,
                            message: msg,
                            signedMessage: res.sig,
                            pubKey: publicKey
                        },
                        token1,
                        token2,
                        amount,
                        token
                    }
                    dispatch(poolActions.removeLiquidity(payload))
                    setAmount1("")
                    setAmount2("")
                    dispatch(poolActions.clearRemoveQuote())
                    handleClose()                   
                } else {
                    dispatch(walletActions.setWalletMsg('Invalid signature !'))
                }
            } else {
                setSnackBarVisible(true)    
                dispatch(poolActions.poolSigningCancelled())
                console.log('sign failed: ', res)
            }
            
        }
         catch (err) {
            console.error('remove liquidity request cancelled: ', err)
            setSnackBarVisible(true)
            dispatch(poolActions.poolSigningCancelled())
        }
    }
}

export const LogOut = (dispatch, address, chainId, network, setAddress, setChainId, setNetwork, setPublicKey, setDappConnected, setWallet, setStartWatch, setWalletDisconnected) => {
    console.log('Log Out !!!')
    setAddress('')
    setChainId(0)
    setNetwork('')
    setPublicKey('')
    setDappConnected(false)
    setWalletDisconnected(true)
    setWallet({
        name: '',
        alias: '',
        icon: Unknown,
    })
    setStartWatch(false)
    dispatch(authActions.logOut(address, chainId, network))
}



